import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import StandardList from '../common/listing/list.component.jsx'
import NoResult from '../common/listing/noresult.component.jsx'
import LoadingSpinner from "../common/spinner/loading.component.jsx"
import ItemReportPopover from './ItemReportPopover'

class ItemReportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            headers: [],
            rows: [],
            totalItemsCount: 0,
            orderByField: 'orderIdentifier'
        }
        this.formatData = this.formatData.bind(this)
        this.sortRows = this.sortRows.bind(this)
    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.productId != this.props.productId || prevProps.filters != this.props.filters )
        {
            this.fetchData()
        }
    }

    fetchData() {
        this.setState({
            loading: true,
        })

        AppContext.getApiClient().post('/reports/item-reports', {
            filters: this.props.filters,
            productId: this.props.productId,
            keywords: this.props.searchKeywords,
            fields: this.props.fields,
            aggregationField: "orderId"
        }).then(res => {
            const r = res
            this.setState({
                headers: r.length > 0 ? this.headers() : [],
                rows: r.length > 0 ? this.sortRows(this.state.orderByField, this.formatData(r)) : '',
                totalItemsCount: res.length,
                loading: false,
            })
        })
    }

    formatData(data) {
        const orders = {}
        let rows = []
        for (let item of data) {

            let row = {
                orderId: '',
                orderIdentifier: '',
                totalOnOrder: 0,
                inventoryReserved: 0,
                requestedWithPo: 0,
                inventoryRequested: 0,
                invoicedMeasure: 0,
                inventoryReceived: 0,
            }

            row.orderId = item.attributes.orderId
            row.orderIdentifier = item.attributes.orderIdentifier
            row.totalOnOrder = item.attributes.totalOnOrder
            row.inventoryReserved = item.attributes.inventoryReserved
            row.requestedWithPo = item.attributes.requestedWithPo
            row.inventoryRequested = item.attributes.requestedWithPo > 0 ? item.attributes.inventoryRequested - item.attributes.requestedWithPo : item.attributes.inventoryRequested
            row.invoicedMeasure = item.attributes.invoicedMeasure
            row.inventoryReceived = item.attributes.inventoryReceived
            orders[item.attributes.orderId] = row
        }

        for (let i in orders) {
            rows.push(orders[i])
        }
        return rows
    }

    sortRows(field, unsortedData) {
        const asc = false
        let data = unsortedData.sort(this.compareBy(field, asc))

        return data.slice(0, 50).map(q => this.row(q))
    }

    compareBy(key, asc) {
        let reverse = asc ? 1 : -1;
        return function (a, b) {
            if (a[key] < b[key])
                return -1 * reverse;
            if (a[key] > b[key])
                return 1 * reverse;
            return 0;
        };
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="order.listing.headers.id_label"
                defaultMessage="ID"
            />
        ]
        let classNames = ['']
        headers = headers.concat([
            <FormattedMessage
                id="item_order_report.total_on_order"
                defaultMessage="Total"
            />,
            <FormattedMessage
                id="item_order_report.inventory_reserved"
                defaultMessage="Reserved"
            />,
            <FormattedMessage
                id="item_order_report.inventory_requested_PO"
                defaultMessage="With PO"
            />,
            <FormattedMessage
                id="item_order_report.inventory_requested"
                defaultMessage="Without PO"
            />,
            <FormattedMessage
                id="item_order_report.inventory_invoiced"
                defaultMessage="Invoiced"
            />,
        ])

        classNames = classNames.concat(['', '', '', '',])
        return {
            classNames: classNames,
            data: headers,
        }

    }

    row(order) {

        const orderId = order.orderId
        const orderIdentifier = order.orderIdentifier
        const requestedWithPo = order.requestedWithPo
        const requested = order.inventoryRequested
        const reserved = order.inventoryReserved
        const invoiced = order.invoicedMeasure
        const totalOnOrder = order.totalOnOrder

        let rows = []
        let classNames = ['']

        rows.push
            (
                <span>
                    <Link to={'/orders/' + orderId + '/edit'}>
                        {orderIdentifier}
                    </Link>
                </span>
            )

        rows = rows.concat([
            totalOnOrder,
            reserved,
            requestedWithPo,
            requested,
            invoiced,
        ])


        classNames = classNames.concat(['', '', '', '', ''])
        return {
            classNames: classNames,
            rowId: order.orderId,
            data: rows,
        }
    }

    componentWillUnmount() {
        this.props.onClose?.()
    }

    render() {

        const productTitle = this.props.productTitle
        const productSku = this.props.productSku ? 'Sku: ' + this.props.productSku : ''

        let list =
            <StandardList
                smallLine={true}
                headers={this.state.headers}
                rows={this.state.rows}
                footer={this.state.footer}
                footerClassName={'bg-secondary text-white'}
                className={"pt-0"}
            />
    
        if (this.state.loading) {
            list = <LoadingSpinner />
        }

        if (this.props.productId == "" && this.state.rows.length == 0) {
            list = <NoResult noContainer={true} noButton={true}/>
        }

        return (
            <div className="modal-content">
                <div className="modal-header">
                    <div className="h5 modal-title">
                        <span>
                            {productTitle} &nbsp;&nbsp;
                            <small>{productSku}</small>
                        </span>
                    </div>
                </div>

                <div className="modal-body overflow-visible">
                    <ItemReportPopover className="d-flex justify-content-end pr-3 mb-2"/>
                    {list}
                </div>

                <div className="modal-footer justify-content-between">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal">
                        <FormattedMessage
                            id="template.sections.sort.modal.close_btn"
                            defaultMessage="Close"
                        />
                    </button>
                </div>
            </div>
        );
    }
}
export default injectIntl(ItemReportModal);


// WEBPACK FOOTER //
// ./src/order/itemreportmodal.component.jsx